import React, {useContext, useEffect, useState} from 'react';
import Banner from "../components/Banner";
import {Button, Container, Grid, MobileStepper, Snackbar, Typography, useMediaQuery} from "@material-ui/core";
import FeaturedSession from "../components/FeaturedSession";
import {Link, useHistory} from "react-router-dom";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import calender from "../../assests/images/Vectorcalender.svg";
import location from "../../assests/images/Vectorlocation.svg";
import SwipeableViews from 'react-swipeable-views';
import {KeyboardArrowLeft, KeyboardArrowRight} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Branding from '../components/Branding';
import {JsonContext} from "../../Context";
import SimpleModal from "../components/Modal";
import {Alert} from "@material-ui/lab";
import {fetchStreamJson} from "../../utils/api";

const useStyles = makeStyles((theme) => ({
    link:{
        textDecoration: 'none',
        color: 'inherit',
    },
    align: {
        display: 'inline-block',
        verticalAlign: 'sub',
        marginRight: '15px'
    },    
    dots: {
        bottom: '30px',
        position: 'absolute',
        margin: '0 auto',
        left: 0,
        width: '44px',
        right: 0,
    },
    dot:{
        background: 'grey'
    },
    dotActive: {
        background: '#FFFFFF'
    }
}));
export default function Home(){
    const theme = useTheme()
    const classes = useStyles();
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("xs"));
    const data = useContext(JsonContext).homePage;
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = 3;
    let history = useHistory();
    const [openModal, setOpenModal] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [selectedSession, setSelectedSession] = useState(null);
    const [streamData, setStreamData] = useState({});
    const toggleModal = (session)=>{
        !openModal ? setSelectedSession(session) : setSelectedSession(null)
        setOpenModal(!openModal);
    }
    const onSubmit = (status=false) => {
        status ? history.push({
            pathname: `/watch/${selectedSession.id}`,
            state: {}
        }) : setOpenSnack(true)
        toggleModal();
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep<maxSteps-1 ? prevActiveStep + 1 : maxSteps-1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep && prevActiveStep - 1);
    };

    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    const renderFeaturedSessions = ()=>{
        return data.featuredSessions.map((session)=>{
            return <FeaturedSession key={`session_${session.id}`} data={session} toggleModal={toggleModal} videoData={streamData[session.stream]}/>
        });
    };
    useEffect(async ()=>{
        window.scrollTo({top:0});
        document.title = data.title;
        let streamObj = {};
        for (let j = 0; j < data.featuredSessions.length; j++) {
            const stream = data.featuredSessions[j].stream;
            if (!(!!streamObj[stream])){
                await fetchStreamJson(stream).then(data=>{
                    streamObj[stream] = data;
                });
            }
        }
        setStreamData(streamObj);
    },[])
    return <>
        <Banner data={data.banner}/>

        <div style={{backgroundColor: theme.palette.background.primary}}>
            <Container maxWidth={'lg'}>
                <Grid container spacing={2} style={{paddingTop: '18px', paddingBottom: '18px'}} >
                    <Grid item xs={12} md={2} style={{textAlign: 'left'}}>
                        <img src={calender} alt="Calendar" className={classes.align} /> <Typography component={'span'} variant={'body1'} style={{fontFamily: 'Manrope'}}>9 - 13 March 2022</Typography>
                    </Grid>
                    <Grid item xs={12} md={2} style={{textAlign: 'left'}}>
                        <img src={location} alt="Location" className={classes.align} /> <Typography component={'span'} variant={'body1'} style={{fontFamily: 'Manrope'}}>Brisbane</Typography>
                    </Grid>
                </Grid>
            </Container>
        </div>

        <Container maxWidth={'lg'} style={{position: 'relative'}}>
            <Grid container spacing={2} style={{paddingTop: '32px'}}>
                <Grid item xs={9} md={6}>
                    <Typography component={'h2'} variant={'h2'}>
                        Featured Sessions
                    </Typography>
                </Grid>
                <Grid item md={6} xs={3} style={{textAlign: 'right'}}>
                    {!isSmallScreen ? <Link to={'/schedule'} className={classes.link}>
                        <Typography variant={'overline'}>
                        See all events >
                        </Typography>
                        </Link>:
                        <MobileStepper
                            style={{backgroundColor:'transparent'}}
                            variant="dots"
                            steps={maxSteps}
                            classes={{
                                dots: classes.dots,
                                dot: classes.dot, // this will overrides default styles related to dot elements
                                dotActive: classes.dotActive,
                            }}
                            position="static"
                            activeStep={activeStep}
                            sx={{ maxWidth: 400, flexGrow: 1 }}
                            nextButton={
                                <IconButton style={{color: activeStep === maxSteps-1?theme.palette.button.disable:theme.palette.button.primary}} size="small" onClick={handleNext} disabled={activeStep === maxSteps-1}>
                                    {theme.direction === 'rtl' ? (
                                        <KeyboardArrowLeft />
                                    ) : (
                                        <KeyboardArrowRight />
                                    )}
                                </IconButton>
                            }
                            backButton={
                                <IconButton style={{color: activeStep === 0?theme.palette.button.disable:theme.palette.button.primary}} size="small" onClick={handleBack} disabled={activeStep === 0}>
                                    {theme.direction === 'rtl' ? (
                                        <KeyboardArrowRight />
                                    ) : (
                                        <KeyboardArrowLeft />
                                    )}
                                </IconButton>
                            }
                        />
                    }
                </Grid>
            </Grid>
            {!isSmallScreen ? <Grid container spacing={3} style={{paddingBottom: '32px'}}>
                    {renderFeaturedSessions()}
            </Grid>:

                <Grid container spacing={2} style={{paddingBottom: '66px'}}>
                <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                >
                    {renderFeaturedSessions()}
                </SwipeableViews>
                </Grid>}   
        </Container>
        <Branding data={data.brands}/>
        {openModal && <SimpleModal sessionData={selectedSession} open={openModal} onClose={toggleModal} onSubmit={onSubmit}/>}
        <Snackbar open={openSnack} autoHideDuration={6000} onClose={()=>setOpenSnack(false)} anchorOrigin={{ vertical:'top', horizontal:'right' }}>
            <Alert onClose={()=>setOpenSnack(false)} severity="error" sx={{ width: '100%' }}>
                Enter correct email id and event code.
            </Alert>
        </Snackbar>
    </>
}